module.exports = __webpack_public_path__ + "static/media/pallet.d5e48d22.svg";